/* empty css                              */
import n from "./td-longtail-vue-components98.js";
const i = {
  name: "GridRow",
  props: {
    alignH: {
      type: String,
      default: "start",
      validator(t) {
        return ["center", "end", "start", "space-between", "space-between"].includes(t);
      }
    },
    alignV: {
      type: String,
      default: null,
      validator(t) {
        return ["", "center", "end", "start"].includes(t);
      }
    },
    noGutter: { type: Boolean },
    clearPadding: { type: Boolean }
  },
  computed: {
    classes() {
      const t = [];
      return this.alignH && t.push(`grid-row--h-${this.alignH}`), this.alignV && t.push(`grid-row--v-${this.alignV}`), this.noGutter && t.push("grid-row--no-gutter"), this.clearPadding && t.push("grid-row--clear-padding"), t;
    }
  }
};
var a = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "grid-row", class: e.classes }, [e._t("default")], 2);
}, s = [], o = /* @__PURE__ */ n(
  i,
  a,
  s,
  !1,
  null,
  "03390329"
);
const c = o.exports;
export {
  c as default
};
